import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ObjectBaseComponent} from "../../../../../core/shared/object/mvs-object-base/object-base.component";


@Component({
    selector: 'ol-outlet-content-type-object-component',
    templateUrl: 'ol-outlet-content-type-object.component.html',
    standalone: false
})
export class OlOutletContentTypeObjectComponent extends ObjectBaseComponent implements OnInit, OnChanges, OnDestroy {


    /**
     * On Object Change.
     */
    onObjectChanged() {

    }

    ngOnChanges(changes: SimpleChanges) {
        if (!this.initialized) {
            return;
        }
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }

}
